// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';

import React from 'react';
import { useHistory } from 'react-router';
import { Row, Col } from 'antd/lib/grid';
import Text from 'antd/lib/typography/Text';
import Button from 'antd/lib/button';
import { GetInstanceTypeChinese, InstanceType } from 'cvat-core/src/enums';

interface Props {
    instanceType: `${InstanceType.TASK}` | `${InstanceType.PROJECT}`;
    id: number;
}

function MdGuideControl(props: Props): JSX.Element {
    const { instanceType, id } = props;
    const history = useHistory();

    return (
        <Row justify='start' className='cvat-md-guide-control-wrapper'>
            <Col span={24}>
                <Text strong className='cvat-text-color'>{`${GetInstanceTypeChinese(instanceType)}描述`}</Text>
                <br />
                <Button
                    onClick={() => {
                        history.push(`/${instanceType}s/${id}/guide`);
                    }}
                >
                    编辑
                </Button>
            </Col>
        </Row>
    );
}

export default React.memo(MdGuideControl);
